import React, { Suspense, lazy } from "react";
import Header from "../components/Header";
import { Box } from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";
import Seo from "../components/SEO";
import FullScreenImage from "../components/FullScreenImage";

// Lazy load components
const Hero = lazy(() => import("./Hero"));
const Reviews = lazy(() => import("./Reviews"));
const WelcomeSection = lazy(() => import("./WelcomeSection"));
const ShopSection = lazy(() => import("./ShopSection"));
const DeliveryApiSection = lazy(() => import("./DeliveryApiSection"));
const HowItWorks = lazy(() => import("./HowItWorks"));
const MDP = lazy(() => import("./MDP"));
const Features = lazy(() => import("./Features"));
const Footer = lazy(() => import("../components/Footer"));

function MogomaApp() {
  const { ref: heroRef, inView: heroInView } = useInView({
    threshold: 0.1,
  });

  const { ref: welcomeRef, inView: welcomeInView } = useInView({
    threshold: 0.1,
  });

  const { ref: shopRef, inView: shopInView } = useInView({
    threshold: 0.1,
  });

  const { ref: apiRef, inView: apiInView } = useInView({
    threshold: 0.1,
  });

  const { ref: featuresRef, inView: featuresInView } = useInView({
    threshold: 0.1,
  });

  const { ref: howItWorksRef, inView: howItWorksInView } = useInView({
    threshold: 0.5,
  });

  const { ref: mdpRef, inView: mdpInView } = useInView({
    threshold: 0.1,
  });

  const { ref: reviewsRef, inView: reviewsInView } = useInView({
    threshold: 0.1,
  });

  let headerBg = "rgba(242, 242, 243, 0.1)";

  if (heroInView) {
    headerBg = "rgba(242, 242, 243, 0.1)";
  } else if (welcomeInView) {
    headerBg = "rgba(0, 0, 0, 0.8)";
  } else if (shopInView) {
    headerBg = "rgba(0, 0, 0, 0.8)";
  } else if (apiInView) {
    headerBg = "rgba(0, 0, 0, 0.8)";
  } else if (featuresInView) {
    headerBg = "rgba(0, 0, 0, 0.8)";
  } else if (howItWorksInView) {
    headerBg = "rgba(242, 242, 243, 0.1)";
  } else if (mdpInView) {
    headerBg = "rgba(0, 0, 0, 0.8)";
  } else if (reviewsInView) {
    headerBg = "rgba(0, 0, 0, 0.8)";
  }

  return (
    <Seo
      title="Mogoma | Delivery, Commerce & Logistics Infrastructure"
      description="Mogoma is a mobile-first commerce and delivery platform enabling package delivery, merchant commerce, USSD shopping and API-powered logistics infrastructure across Botswana."
      keywords="Mogoma, delivery Botswana, logistics marketplace, commerce platform, delivery API, merchant platform, USSD commerce, package delivery Botswana"
    >
      <Box bg="#F3F3F3">
        <Header headerBg={headerBg} />

        <Suspense fallback={<FullScreenImage />}>
          {/* Hero */}
          <Box id="hero" ref={heroRef}>
            <Hero />
          </Box>

          {/* Welcome */}
          <Box
            ref={welcomeRef}
            px={{ base: 2, md: 20 }}
            py={{ base: 4, md: 8 }}
          >
            <WelcomeSection />
          </Box>

          {/* Existing Features */}
          <Box id="features" ref={featuresRef}>
            <Features />
          </Box>

          {/* How It Works */}
          <Box id="how-it-works" ref={howItWorksRef}>
            <HowItWorks />
          </Box>

          {/* Delivery Protection */}
          <Box id="mdp" ref={mdpRef} mb={7}>
            <MDP />
          </Box>


          {/* Shop */}
          <Box id="shop" ref={shopRef}>
            <ShopSection />
          </Box>

          {/* Delivery API */}
          <Box id="delivery-api" ref={apiRef}>
            <DeliveryApiSection />
          </Box>
          {/* Reviews */}
          <Box id="reviews" ref={reviewsRef}>
            <Reviews />
          </Box>

          <Footer />
        </Suspense>
      </Box>
    </Seo>
  );
}

export default MogomaApp;